import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainNavbar from "./components/navbar";
import DualEducation from "./pages/DualEducation";
import NemzetiBajnokok from "./pages/NemzetiBajnokok";
import ElmaradottTersegBruhazas from "./pages/ElmaradottTersegBruhazas";
import BusinessLoanConsulting from "./pages/BusinessLoanConsulting";
import CorporateAccountOptimize from "./pages/CorporateAccountOptimize";
import Footer from "./components/footer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Container from "react-bootstrap/Container";
import Impresszum from "./pages/Impresszum";
import Rolunk from "./pages/Rolunk";
import ThanksPage from "./pages/ThanksPage";
import FrameworkContract from "./pages/FrameworkContract";

export default function App() {
  return (
    <BrowserRouter>
      <MainNavbar />
      <Routes>
        <Route path="/" element={<Rolunk />} />
        <Route path="/nemzeti-bajnokok" element={<NemzetiBajnokok />} />
        <Route path="/dualis-kepzes" element={<DualEducation />} />
        <Route
          path="/elmaradott-tersegek-tamogatasa"
          element={<ElmaradottTersegBruhazas />}
        />
        <Route path="/vallalati-hitel" element={<BusinessLoanConsulting />} />
        <Route
          path="/szamlaoptimalizalas"
          element={<CorporateAccountOptimize />}
        />
        <Route path="/penzugyi-orangyal" element={<FrameworkContract />} />
        <Route path="/adatkezelesi-tajekoztato" element={<PrivacyPolicy />} />
        <Route path="/impresszum" element={<Impresszum />} />
        <Route path="/rolunk" element={<Rolunk />} />
        <Route path="/koszonjuk" element={<ThanksPage />} />
      </Routes>
      <Container className="py-0">
        <Footer />
      </Container>
    </BrowserRouter>
  );
}
